import { IVitalView } from "@/types/vitals.types"

/** Mirrors the backend's battle entry rule: the hero needs at least this share of max HP. */
export const BATTLE_ENTRY_HP_RATIO = 0.3

const HP_VITAL_CODE = "hp"

export const isBelowBattleEntryHp = (
  vitals: readonly IVitalView[]
): boolean => {
  const hp = vitals.find((vital) => vital.code === HP_VITAL_CODE)
  return hp !== undefined && hp.current < hp.max * BATTLE_ENTRY_HP_RATIO
}
